import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/modals.css';
import { Button, Modal } from 'react-bootstrap';

interface props {
  showModal: boolean;
  closeModal: () => void;
}

export default function ScheduleDemo({ showModal = false, closeModal }: props) {
  return (
    <>
      <Modal
        show={showModal}
        onHide={closeModal}
        dialogClassName="ec-modal-schedule-demo"
        contentClassName="ec-modal-content"
      >
        <Modal.Header className="ec-modal-header" closeButton>
          <Modal.Title className="ec-modal-title">
            Contact Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ec-modal-body">
          <iframe
            className="ec-schedule-demo-iframe"
            src="/public/meetings.html"
            title="HubSpot Form"
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
}
